import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  roles: string[] = [];
  tipoDocumento: string = "";
  numIdentificacion: string = "";
  nombres: string = "";
  apellidos: string = "";
  seccional: string = "";
  idSeccional: string = "";
  dependencia: string = "";
  idDependencia: string = "";
  correo: string = "";
  activo: string = "";
  r3244: boolean = false;
  r3246: boolean = false;
  r3247: boolean = false;
  userinfo: string = "";
  path: string = "";
  lenguaje: boolean = true;
  verarchivos: boolean = true;
}
